import {
  ContentOrderByEnum,
  ContentType as GqlContentType,
  OrderDirectionEnum,
} from '../../../../generated/graphql/types';
import {
  type GetKnowledgehubContentByCollaboratorQuery,
  useGetKnowledgehubContentByCollaboratorQuery,
} from './graphql/get-knowledgehub-content-by-collaborator.v5.generated';
import { transformToWidgetData } from './utils';

type TEdgeNode = NonNullable<
  NonNullable<
    NonNullable<
      GetKnowledgehubContentByCollaboratorQuery['knowledge_hub']
    >['knowledge_hub_content_by_collaborator']
  >['edges'][number]['node']
>;

type TUseLearningAvailableContentsProps = {
  first?: number;
  contentType?: GqlContentType;
};

export const useLearningAvailableContents = ({
  first = 5,
  contentType = GqlContentType.ContentTypeCourse,
}: TUseLearningAvailableContentsProps) => {
  const { data, loading, error, refetch } =
    useGetKnowledgehubContentByCollaboratorQuery({
      variables: {
        input: {
          first,
          content_types: [contentType],
          is_new_content: true,
          order_by: [
            {
              field: ContentOrderByEnum.Title,
              direction: OrderDirectionEnum.Asc,
            },
          ],
        },
      },
      context: {
        clientName: 'v5',
      },
    });

  const nodes = (
    data?.knowledge_hub?.knowledge_hub_content_by_collaborator?.edges ?? []
  )
    .map(edge => edge?.node)
    .filter(Boolean) as TEdgeNode[];
  const contents = transformToWidgetData(nodes, contentType);

  return {
    contents,
    loading,
    error,
    refetch,
  };
};
